export enum PowerDocsEventsName {
  CREATE_DOCUMENT = 'create_power_doc',
  GENERATE_QUOTATION = 'generate_quotation',
  GENERATE_PROPOSAL = 'generate_proposal',
  GENERATE_OFFER = 'generate_offer',
  GENERATE_SUBDOCUMENT = 'generate_subdoc',
  PROPOSAL_GENERATED = 'proposal_generated',
  PROPOSAL_CHUNK = 'proposal_chunk',
  PROPOSAL_SECTION = 'proposal_section',
  PROPOSAL_DONE = 'proposal_done',
  QUOTATION_GENERATED = 'quotation_generated',
  QUOTATION_CHUNK = 'quotation_chunk',
  QUOTATION_SECTION = 'quotation_section',
  QUOTATION_DONE = 'quotation_done',
  OFFER_GENERATED = 'offer_generated',
  OFFER_CHUNK = 'offer_chunk',
  OFFER_SECTION = 'offer_section',
  OFFER_DONE = 'offer_done',
  CUSTOM_GENERATED = 'custom_generated',
  CUSTOM_CHUNK = 'custom_chunk',
  CUSTOM_SECTION = 'custom_section',
  CUSTOM_DONE = 'custom_done',
  POWERDOC_CREATED = 'power_doc_created',
  ASSIGN_TO_MEMBER = 'assign_section_to_member',
  UPDATE_SECTION_DUE_DATE = 'update_section_due_date',
  UPDATE_POWERDOC_DUE_DATE = 'update_powerdoc_due_date',
  UPDATE_POWERDOC_STATUS = 'update_powerdoc_status',
  UPDATE_SECTION_PROGRESS = 'update_section_progress',
  UPDATE_POWERDOC_CONTENT = 'update_powerdoc_content',
  CREATE_NEW_SECTION = 'create_new_section',
  REORDER_POWERDOC_SECTIONS = 'reorder_sections',
  TRACK_SECTION_VIEW = 'track_section_view',
  UPDATE_POWERDOC_CONTACT = 'update_powerdoc_contact',
  UPDATE_POWERDOC_DEPARTMENT = 'update_powerdoc_department',
  DELETE_ATTACHMENT = 'delete_powerdoc_attachment',
  SAVE_TEMPLATE = 'save_powerdoc_template',
  ADD_TENDER_TO_PIPELINE = 'add_tender_to_pipeline',
  ADD_TENDER_TO_USER = 'add_tender_to_user',
  ADMIN_SET_PIPELINE_PHASE = 'admin_set_pipeline_phase',
  ADMIN_SET_VALUE = 'admin_set_tender_value',
  DISMISS_TENDERS = 'dismiss_tenders',
  REQUEST_CHANGES = 'request_changes',
  REJECT_TENDER = 'reject_tender',
  SELECT_FREE_TIER = 'select_free_tier'
}
